// I'm terribly sorry about this in particular

function dirtyColumnResize(columns: Element, selectors: string[]) {
  selectors.forEach((selector: string) => {
    const heights = [...columns.querySelectorAll(selector)].map((node) => {
      const {height} = node.getBoundingClientRect();
      return height;
    });
    const maxHeight = Math.max(...heights);

    columns.querySelectorAll(selector).forEach((node) => {
      (node as HTMLElement).style.height = `${maxHeight}px`;
    });
  });
}

function enjoyYourLayoutShift() {
  if (window.innerWidth < 782) {
    return;
  }
  document.querySelectorAll('main .wp-block-columns').forEach((columns) => {
    const selectors = ['.wp-block-heading', 'p'];
    dirtyColumnResize(columns, selectors);
  });
}

export default function main() {
  window.addEventListener('load', enjoyYourLayoutShift);
  window.addEventListener('resize', enjoyYourLayoutShift);
}
